import axios from "axios";
import { VENDORID } from "../constants";

//get setting
 export async function getStripeIntentId(sessionId) {
    var request = await axios.post("https://stripe.mobiapi.de/get-payment-intent", {
      vendorId: VENDORID,
      token: sessionStorage.getItem('token'),
      session_id: sessionId,
    });
    return request.data;
  }